import { TableMapping } from "./get-localized-item-size";

/**
 * Get the global item size from the localized size
 * @param localizedSize - The localized size
 * @param tableMapping - The table mapping
 * @returns The global item size
 */
export function getGlobalItemSize(
  localizedSize: string,
  tableMapping: TableMapping,
): string {
  const dividerSymbol = tableMapping.dividerSymbol;
  const localXSize = localizedSize.split(dividerSymbol)[0];
  const localYSize = localizedSize.split(dividerSymbol)[1];

  if (!localXSize && !localYSize) {
    return localizedSize;
  }

  let globalXSize = localXSize;
  let globalYSize = localYSize;

  if (!Array.isArray(tableMapping.x)) {
    const xEntry = Object.entries(tableMapping.x).find(
      ([, value]) => value === localXSize,
    );
    if (xEntry) {
      globalXSize = xEntry[0];
    }
  }

  if (!Array.isArray(tableMapping.y)) {
    const yEntry = Object.entries(tableMapping.y).find(
      ([, value]) => value === localYSize,
    );
    if (yEntry) {
      globalYSize = yEntry[0];
    }
  }

  if (globalYSize) {
    return `${globalXSize}${dividerSymbol}${globalYSize}`;
  }

  return globalXSize;
}
